import { generateRepositoryMethods } from './repository.types.js';
export const userRepositoryMethods = generateRepositoryMethods({
    integrateInsuranceUser: {
        callMethod: 'POST',
        endpoint: '/user/integrate-insurance',
    },
    getOauthAuthorizationUrl: {
        callMethod: 'GET',
        endpoint: '/user/authorization-url',
    },
    linkInsuranceUserWithOAuthCode: {
        callMethod: 'POST',
        endpoint: '/user/oauth/link-insurance',
    },
    linkInsuranceUser: {
        callMethod: 'POST',
        endpoint: '/user/link-insurance',
    },
    getAccountMetaInformation: {
        callMethod: 'GET',
        endpoint: '/user/account/meta-information',
    },
    createInsuranceMapping: {
        callMethod: 'POST',
        endpoint: '/user/create-insurance-mapping',
    },
});
//# sourceMappingURL=user.methods.js.map